import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const NeedSiteAdministratorMessage = () => (
  <SectionMessage>
    <FormattedMessage
      id="mac.licenses.need-site-administrator"
      defaultMessage="You will need to be a site administrator of your Atlassian Cloud site to add new users and try new products and apps."
    />
    {` `}
    <a href="https://www.atlassian.com/licensing/cloud/managing#overview-1">
      <FormattedMessage
        id="mac.licenses.need-site-administrator.learn-more"
        defaultMessage="Learn more"
      />
    </a>
  </SectionMessage>
);
